import gql from 'graphql-tag';

const GET_CONTROL_GROUP = gql`
  query getControlGroup($params: ReportInput!) {
    controlGroup(params: $params) {
      salesPerSubscriber {
        control
        exposed
      }

      rawAov {
        control
        exposed
      }

      indexedFrequency {
        control
        exposed
      }

      liftResults {
        transactionsPerUserLiftPercent
        aovLiftPercent
        liftPercent
        periodStart
      }

      overallLiftPercent
      overallAovLiftPercent
      overallTransactionsPerUserLiftPercent
    }
  }
`;

export default GET_CONTROL_GROUP;
